import { render, staticRenderFns } from "./HomePage_it.vue?vue&type=template&id=4382366e&"
import script from "./HomePage_it.vue?vue&type=script&lang=js&"
export * from "./HomePage_it.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports